export default __webpack_public_path__ + "static/media/iconly-bold-tick-square.21d82c3d.svg";